<template>
  <div class="flex w-full flex-col gap-3">
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.canVisit') }}</span>
      <span class="shrink-0 text-right">{{ formatBoolean(detail?.can_visit) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.deliveryPrice') }}</span>
      <span class="shrink-0 text-right">{{ formatMoney(detail?.delivery_price) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.expressDeliveryPrice') }}</span>
      <span class="shrink-0 text-right">{{ formatMoney(detail?.express_delivery_price) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.freeDeliveryAmount') }}</span>
      <span class="shrink-0 text-right">{{ formatMoney(detail?.free_delivery_after_price) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.minOrderAmount') }}</span>
      <span class="shrink-0 text-right">{{ formatMoney(detail?.min_delivery_price) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.acceptCash') }}</span>
      <span class="shrink-0 text-right">{{ formatBoolean(detail?.accept_cash_payment) }}</span>
    </div>
    <div class="flex justify-between gap-4">
      <span class="font-semibold">{{ $t('page.acceptCard') }}</span>
      <span class="shrink-0 text-right">{{ formatBoolean(detail?.accept_terminal_payment) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryTerms',
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    formatBoolean(value) {
      if (value === null || value === undefined) {
        return '—';
      }

      return this.$t(value ? 'page.yes' : 'page.no');
    },
    formatMoney(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }

      return `${value} TMT`;
    },
  },
};
</script>
